module.exports = __webpack_public_path__ + "static/img/695_phase_function_Paper_PointsHejduk_Prediction.0878034.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/695_phase_function_Paper_PointsHejduk_Prediction.png
// module id = a6Wk
// module chunks = 0